function routePath(url: string): string {
  return String(url ?? '').split(/[?#]/, 1)[0];
}

/** True only when navigation activates another page, not when filters update the URL. */
export function isDifferentRoutePath(currentUrl: string, nextUrl: string): boolean {
  return routePath(currentUrl) !== routePath(nextUrl);
}
